import CommonService from '../services/common.service'
import { ErrorCodeConstants } from '@/supports/error-code.constants'
import { AppConstant } from '@/supports/app.constant'
// import { store } from '@/store'

const BEARER_ALIAS = 'Bearer '

/**
 * Interceptor handler add access token and refresh token when access token expire
 */
export default new (class AuthorizeJwtInterceptor {
  /**
   * Add Authorization access token in header request
   * @param axiosInstance
   */
  setAuthorizationHeader(axiosInstance: any) {
    axiosInstance.interceptors.request.use((config: any) => {
      const accessToken = CommonService.getTokenAuth()
      if (accessToken) {
        config.headers['Authorization'] = BEARER_ALIAS + accessToken
      }
      return config
    })
  }

  renewAccessToken(axiosInstance: any) {
    axiosInstance.interceptors.response.use(
      (res: any) => {
        const accessToken = res.headers.get('Authorization')
        // Add access token after renew
        if (accessToken) {
          CommonService.setAccessToken(accessToken.replace(BEARER_ALIAS, ''))
        }
        const renewAccessToken = res.headers.get('New-Access-Token')
        if (renewAccessToken) {
          CommonService.setAccessToken(renewAccessToken.replace(BEARER_ALIAS, ''))
        }
        return res
      },
      (err: any) => {
        const originalConfig = err.config
        if (originalConfig.url !== AppConstant.ROUTE_PATH_API_LOGIN && err.response) {
          if (
            err.response.data.code === ErrorCodeConstants.ERROR_TOKEN_EXPIRED ||
            err.response.data.code === ErrorCodeConstants.ERROR_TOKEN_INVALID
          ) {
            const refreshToken = CommonService.getRefreshTokenAuth()
            const accessToken = originalConfig.headers.get('Authorization')
              ? originalConfig.headers.get('Authorization').replace(BEARER_ALIAS, '')
              : ''
            if (refreshToken && refreshToken !== accessToken) {
              // Request api renew access token
              originalConfig.headers['authorization-refresh-flag'] = 'true'
              CommonService.setAccessToken(refreshToken)
              return axiosInstance(originalConfig)
            }

            CommonService.clearTokenAuth()
            window.location.href = AppConstant.ROUTE_PATH_LOGIN
          }
        }

        return Promise.reject(err)
      }
    )
  }
})()
